// @ts-nocheck

// import Header from "components/admin-panel/Header.tsx";
import MainPanel from "../components/adminPanel/adminPanelTemplate/MainPanel";
import SidePanel from "../components/adminPanel/adminPanelTemplate/SidePanel";
import "../components/adminPanel/admin-panel.scss";
import { useState, useEffect } from "react";
import useAxios from "../services/useAxios";
import { useParams } from "react-router-dom";
// import Loader from "utils/Loader";
import { CgProfile } from "react-icons/cg";
import { BsCardChecklist } from "react-icons/bs";
import { BsWallet2 } from "react-icons/bs";
import { useLocation } from "react-router-dom";
import { IoSettingsOutline } from "react-icons/io5";
import { CgExtensionAdd } from "react-icons/cg";
import {
  HiOutlineLocationMarker,
  HiOutlineClipboardList
} from "react-icons/hi";
import { BsBasket2, BsCreditCard2Back } from "react-icons/bs";
import logo from "../assets/images/logo/Sabadi.svg";

export default function AdminPanel() {
  let hash = useLocation();
  const [activeButton, setActiveButton] = useState(-1);

  // const [supplierData, setSupplierData] = useState({});
  const [otherInfo, setOtherInfo] = useState({
    state: "",
    city: "",
    address: "",
    title: "",
    start_hour: "",
    end_hour: "",
    start_min: "",
    end_min: "",
    min_order_amount: 0,
    logo: [],
    cover: [],
    tell1: "",
    tell2: "",
    mobile: "",
    email: ""
  });
  const [images, setImages] = useState({
    cover: "",
    log: ""
  });
  console.log("object", images);
  const [updater, setUpdater] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  let supplierId = useParams();
  const { loading, execute: getAddEdit } = useAxios(
    "superadminapi/get_edit_suppliers_data"
  );
  async function getEditFun(params: type) {
    await getAddEdit({
      supplier_id:
        supplierId.supplier_id != undefined ? supplierId.supplier_id : ""
    }).then(datas => {
      console.log("object", datas.logo_file.path);
      // setSupplierData(datas.supplier[0]);
      setOtherInfo(datas.supplier[0]);
      console.log(datas, "datas500");
      setImages(prev => {
        return {
          ...prev,

          // cover: datas.cover_file.length > 0 ? datas.cover_file.path : "",
          // log: datas.logo_file.length > 0 ? datas.logo_file.path : "",
          cover:
            Object.keys(datas.cover_file).length > 0
              ? datas.cover_file.path
              : "",
          log:
            Object.keys(datas.logo_file).length > 0 ? datas.logo_file.path : ""
        };
      });
    });
  }

  useEffect(() => {
    async function LoadPage() {
      getEditFun();
      setIsLoading(false);
    }
    if (supplierId.supplier_id != undefined) LoadPage();
  }, [updater]);

  const changeHandler = (names, value) => {
    if (names == "start") {
      setOtherInfo(prev => {
        return {
          ...prev,
          start_hour: value.split(":")[0],
          start_min: value.split(":")[1]
        };
      });
    } else if (names == "finish") {
      setOtherInfo(prev => {
        return {
          ...prev,
          finish_hour: value.split(":")[0],
          finish_min: value.split(":")[1]
        };
      });
    }
  };
  function inputChangeHandler(event: Event) {
    setOtherInfo({ ...otherInfo, [event.target.name]: event.target.value });
  }
  function inputFileHandler(event: Event) {
    setOtherInfo({ ...otherInfo, [event.target.name]: event.target.files[0] });
  }
  return (
    <div
      className="admin-panel txt-t1-m"
      style={{ backgroundColor: "#f3eeea" }}
    >
      {/* تب شدن دکمه ها */}
      {/* <Header cover={images.cover} /> */}
      {/* {isLoading && <Loader />} */}
      <div className="panels ">
        <div
          className=" d-flex justify-content-center  align-items-center title-container2 mt-5"
          style={{ flexDirection: "column" }}
        >
          <div
            style={{ width: "130px" }}
            className="image-input text-center d-flex align-items-center justify-content-center  rounded-pill"
          >
            {images.log != "" ? (
              <div
                className="img-responsive"
                style={{ width: "120px", height: "120px" }}
              >
                <img
                  src={`https://sabadi.ir/api/${images.log}`}
                  // src={logo}
                  className="w-100 shadow"
                  style={{
                    borderRadius: "50%",
                    width: "120px",
                    height: "120px"
                  }}
                />
              </div>
            ) : (
              <div className="img-responsive">
                <img src={logo} style={{ width: "120px", height: "120px" }} />
              </div>
            )}
          </div>
          <div className="mt-3 text-center text-resp">
            <h5>{otherInfo.title}</h5>

            {/* <br /> */}
            <HiOutlineLocationMarker className="me-1" />
            {otherInfo.address}
          </div>
        </div>
        <div className="panel-item mx-auto side-panel col-3">
          <SidePanel otherInfo={otherInfo} logos={images.log} />
        </div>
        <div className="panel-item main-panel mx-auto col-8 col-xl-8 admin-panel">
          <div className="admin-btn d-flexjustify-content-evenly ">
            <div className="d-flex justify-content-center responsive-btns">
              <div className="align-items-start sidebarInfo">
                <div
                  className="nav d-flex nav-pills"
                  id="v-pills-tab"
                  role="tablist"
                  aria-orientation="vertical"
                >
                  <button
                    className={`nav-link nav-link-res side  ${hash.hash !=
                      "#orders" && "active"}`}
                    id="v-pills-profile-tab"
                    data-bs-toggle="pill"
                    data-bs-target="#pills-setting"
                    type="button"
                    role="tab"
                    aria-controls="v-pills-profile"
                    aria-selected="true"
                    onClick={e => {
                      setActiveButton(-1);
                    }}
                  >
                    <span
                      className={`befor-active ${activeButton === -1 &&
                        " selectedBtn-sid"}`}
                    >
                      <IoSettingsOutline
                        style={{ color: "#ff4734" }}
                        className={`icon-size  ${activeButton === -1 &&
                          "icon-color"}`}
                      />
                    </span>
                    <span
                      className={`text-responsive  ${activeButton === -1 &&
                        "text-responsive2"}`}
                      style={{ marginLeft: 10 }}
                    >
                      تنظیمات
                    </span>
                  </button>
                  <button
                    className="nav-link nav-link-res side"
                    id="v-pills-finance-tab"
                    data-bs-toggle="pill"
                    data-bs-target="#pills-define-product"
                    type="button"
                    role="tab"
                    aria-controls="v-pills-finance"
                    aria-selected="false"
                    onClick={e => {
                      setActiveButton(1);
                    }}
                  >
                    <span
                      className={`befor-active ${activeButton === 1 &&
                        " selectedBtn-sid"}`}
                    >
                      <CgExtensionAdd
                        style={{ color: "#ff4734" }}
                        className={`icon-size  ${activeButton === 1 &&
                          "icon-color"}`}
                      />
                    </span>
                    <span
                      className={`text-responsive  ${activeButton === 1 &&
                        "text-responsive2"}`}
                      style={{ marginLeft: 10 }}
                    >
                      تعریف کالا
                    </span>
                  </button>
                  <button
                    className={`nav-link nav-link-res side  ${hash.hash ==
                      "#orders" && " active"}`}
                    id="v-pills-orders-tab"
                    data-bs-toggle="pill"
                    data-bs-target="#pills-orders"
                    type="button"
                    role="tab"
                    aria-controls="v-pills-orders"
                    aria-selected="false"
                    onClick={e => {
                      setActiveButton(2);
                    }}
                  >
                    <span
                      className={`befor-active ${activeButton === 2 &&
                        " selectedBtn-sid"}`}
                    >
                      <HiOutlineClipboardList
                        style={{ color: "#ff4734" }}
                        className={`icon-size  ${activeButton === 2 &&
                          "icon-color"}`}
                      />
                    </span>

                    <span
                      className={`text-responsive  ${activeButton === 2 &&
                        "text-responsive2"}`}
                      style={{ marginLeft: 10 }}
                    >
                      سفارشات{" "}
                    </span>
                  </button>
                  <button
                    className={`nav-link nav-link-res side  ${hash.hash ==
                      "#orders" && " active"}`}
                    id="v-pills-orders-tab"
                    data-bs-toggle="pill"
                    data-bs-target="#pills-basket-maker"
                    type="button"
                    role="tab"
                    aria-controls="v-pills-orders"
                    aria-selected="false"
                    onClick={e => {
                      setActiveButton(3);
                    }}
                  >
                    <span
                      className={`befor-active ${activeButton === 3 &&
                        " selectedBtn-sid"}`}
                    >
                      <BsBasket2
                        style={{ color: "#ff4734" }}
                        className={`icon-size  ${activeButton === 3 &&
                          "icon-color"}`}
                      />
                    </span>

                    <span
                      className={`text-responsive  ${activeButton === 3 &&
                        "text-responsive2"}`}
                      style={{ marginLeft: 10 }}
                    >
                      سبدساز{" "}
                    </span>
                  </button>
                  <button
                    className={`nav-link nav-link-res side  ${hash.hash ==
                      "#orders" && " active"}`}
                    id="v-pills-orders-tab"
                    data-bs-toggle="pill"
                    data-bs-target="#pills-finance"
                    type="button"
                    role="tab"
                    aria-controls="v-pills-orders"
                    aria-selected="false"
                    onClick={e => {
                      setActiveButton(4);
                    }}
                  >
                    <span
                      className={`befor-active ${activeButton === 4 &&
                        " selectedBtn-sid"}`}
                    >
                      <BsCreditCard2Back
                        style={{ color: "#ff4734" }}
                        className={`icon-size  ${activeButton === 4 &&
                          "icon-color"}`}
                      />
                    </span>

                    <span
                      className={`text-responsive  ${activeButton === 4 &&
                        "text-responsive2"}`}
                      style={{ marginLeft: 10 }}
                    >
                      امور مالی{" "}
                    </span>
                  </button>
                </div>
              </div>
            </div>
          </div>
          <MainPanel
            otherInfo={otherInfo}
            changeHandler={changeHandler}
            inputChangeHandler={inputChangeHandler}
            inputFileHandler={inputFileHandler}
            setUpdater={setUpdater}
          />
        </div>
      </div>
    </div>
  );
}
